import { ChangeEvent } from 'react'
import { useSelector } from 'react-redux'

import RemoveProfile from './RemoveProfile'
import { BankDetails } from './BankDetails'
import styles from './LocalProfile.scss'


type Props = {
  field?: string,
  close: (e: ChangeEvent<HTMLElement>) => void,
  route: any
}

const LocalProfile = ({ field, close, route }: Props) => {
  const allowEditBankDetails = useSelector((state: any) => state.user.allow_edit_bank_details)

  return (
    <div>
      {field === 'remove'
        && <RemoveProfile close={close} />}

      {allowEditBankDetails
        && <BankDetails route={route} className={styles.bankDetails} />}
    </div>
  )
}

export default LocalProfile
